import { IconTrash } from "@tabler/icons-react";
import { toast } from "sonner";

import { useTeam } from "@/components/providers/team";
import { useFetchTeamInvites } from "@/components/queries/team";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { buttonVariants } from "@/components/ui/button";
import {
	apiClient,
	requestWithHandling,
	TypedClientApiError,
} from "@/utils/api";

export const CancelInviteDialog = ({ inviteID }: { inviteID: string }) => {
	const { teamID } = useTeam();
	const { refetchInvites } = useFetchTeamInvites(teamID ?? "");
	if (!teamID) return null;
	return (
		<div className="flex items-center gap-2">
			<AlertDialog>
				<AlertDialogTrigger
					className={buttonVariants({
						variant: "destructive",
						size: "icon-sm",
					})}
					aria-label="Cancel invite"
				>
					<IconTrash className="h-4 w-4" />
				</AlertDialogTrigger>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>Cancel Invite</AlertDialogTitle>
						<AlertDialogDescription>
							Are you sure you want to cancel this invite? This action cannot be
							undone.
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel>Cancel</AlertDialogCancel>
						<AlertDialogAction
							onClick={async () => {
								try {
									await requestWithHandling<void>(() =>
										apiClient.api.teamMembersInviteDelete(teamID as string, {
											id: inviteID,
										}),
									);
									toast.success("Invite cancelled successfully");
									refetchInvites();
								} catch (error) {
									toast.error("Failed to cancel invite", {
										description:
											error instanceof TypedClientApiError
												? error.message
												: "An unknown error occurred.",
									});
								}
							}}
						>
							Delete
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</div>
	);
};
